import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';

const StyledHeaderTitle = styled('h1', {
  fontSize: '28px',
  lineHeight: '28px',
  margin: '10px 0',
});

export const PageHeaderTitle = ({ children, styles, ...props }) => {
  return (
    <StyledHeaderTitle
      {...props}
      data-uhc-brand="font--heading color--blue"
      data-testid="search-results-label"
    >
      {children}
    </StyledHeaderTitle>
  );
};

PageHeaderTitle.propTypes = {
  children: PropTypes.node,
  styles: PropTypes.shape({}),
};

PageHeaderTitle.defaultProps = {
  children: null,
  styles: null,
};
